import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CharterPaymentDAO } from '../../../../core/services/dao/charterPaymentDAO';
import { data } from 'jquery';

@Component({
  selector: 'app-hold-processing-failure-dialog',
  templateUrl: './hold-processing-failure-dialog.component.html',
  styleUrls: ['./hold-processing-failure-dialog.component.scss'],
})
export class HoldProcessingFailureDialogComponent implements OnInit {
  failureReason: string;
  userId: number;
  failedAmount: string;
  paymentIntentId: string;
  constructor(
    public dialogRef: MatDialogRef<HoldProcessingFailureDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private charterPaymentDAO: CharterPaymentDAO,
  ) {
    this.failureReason = data.failureReason;
    this.userId = data.userId;
    this.failedAmount = data.failedAmount;
    this.paymentIntentId = data.paymentIntentId;
  }

  ngOnInit(): void {}

  sendFailurePaymentRequest() {
    const failureEmailSub = this.charterPaymentDAO
      .sendFailedPaymentEmailToCustomer(
        this.userId,
        this.failedAmount,
        this.paymentIntentId,
      )
      .subscribe((data) => {
        this.dialogRef.close();
      });
  }
}
